import { v4 } from 'uuid'

export function uuidv4() {
    let manual_uuid4 = v4()
    manual_uuid4 = manual_uuid4.replace("/^.{6}/g", "MANUAL")
    return manual_uuid4
}

export class TriageTask {
    async submit(t3_url, token, method, api, payload, post_actions, fileUpload, environment) {
        let post_task_jira = {}
        let post_task_slack = {}
        let post_task_email = {}
        if (Object.keys(post_actions).length > 0){
            // X-POST-TASK-SLACK
            if(post_actions.slack_channel && post_actions.slack_channel.length > 0) {
                post_task_slack['channel'] = post_actions.slack_channel
                if(post_actions.slack_message) {
                    post_task_slack['message'] = post_actions.slack_message
                }
                if(post_actions.threaded_result) {
                    post_task_slack['threaded_result'] = post_actions.threaded_result
                }
            }

            // X-POST-TASK-EMAIL
            if(post_actions.recipients && post_actions.recipients.length > 0) {
                post_task_email['recipients'] = post_actions.recipients.split(",")
            }
            
            // X-POST-TASK-JIRA
            if(post_actions.jira_description && post_actions.jira_description.length > 0)
            {
                post_task_jira['description'] = post_actions.jira_description
                post_task_jira['environment'] = environment || ''
                post_task_jira['issue_type'] = post_actions.jira_issue_type
                post_task_jira['jira_key'] = post_actions.jira_key || ''
            }
        }

        // Workaround for fix session and bouncer zk
        api = api.replace("/fix/session_", "/fix/session/")
        api = api.replace("/bouncer/zk_account_", "/bouncer/zk/account/")

        let triageTaskURL = t3_url + api

        if (Object.keys(payload).length > 0 ){
            let prms = new URLSearchParams(payload).toString()
            triageTaskURL += '?' + prms
        }

        return new Promise(function(resolve) {
            const xhr = new XMLHttpRequest();
            xhr.open(method, triageTaskURL, true);

            if(Object.keys(post_task_slack).length > 0) {
                xhr.setRequestHeader("X-POST-TASK-SLACK", JSON.stringify(post_task_slack))    
            }

            if(Object.keys(post_task_email).length > 0) {
                xhr.setRequestHeader("X-POST-TASK-EMAIL", JSON.stringify(post_task_email))    
            }

            if(Object.keys(post_task_jira).length > 0) {
                xhr.setRequestHeader("X-POST-TASK-JIRA", JSON.stringify(post_task_jira))    
            }

            xhr.setRequestHeader("Authorization", "Bearer " + token.token)
            xhr.setRequestHeader("ttid", token.user_email)
            xhr.setRequestHeader("triage-app", "ControlCenter")
            xhr.setRequestHeader("triage-app-version", process.env.REACT_APP_VERSION)
            
            let formData = new FormData()
            
            if (fileUpload && fileUpload.size) {
                /*  {
                    path: "xxx.csv",
                    lastModified: 1654221128865,
                    lastModifiedDate: Mon Sep 26 2022 09:00:00 GMT+0800 (Singapore Standard Time),
                    name: "xxx.csv",
                    size: 123456,
                    type: "text/csv",
                    webkitRelativePath: ""
                }
                */
                formData.append('file', new Blob([fileUpload], {type: "text/csv"}))
            }
            // Note that GET requests with files will be dropped as per documentation here. 
            // Tasks with CSV uploads must be in POST!
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/send
            xhr.send(formData);
            
            xhr.onreadystatechange = () => {
                // when fully ready then process the full status
                if (xhr.readyState !== 4) {
                    return
                }

                if (xhr.status === 200) {
                    let response_text = xhr.responseText;
                    // This is needed because of a limitation in javascript in handling more than 53bits numbers
                    response_text = response_text.replace(/("[^"]*"\s*:\s*)(\d{16,})/g, '$1"$2"')
                    let triageResponse = {}
                    try {
                        triageResponse = {
                            status: xhr.status,
                            data: JSON.parse(response_text)
                        }
                    } catch (error) {
                        // It can be 200 but the error object not in JSON form
                        if ((response_text).indexOf("Signature verification") > -1 ) {
                            response_text = "You do not have the required scope: " + response_text
                        }

                        triageResponse = {
                            status: xhr.status,
                            data: {
                                error: response_text
                            }   
                        }
                    }

                    resolve(triageResponse)
                } else {
                    let triageResponse = {
                        status: xhr.status,
                        data: {
                            error: xhr.responseText
                        }   
                    }
                    resolve(triageResponse)
                }
            }
        })
    }
        
}



